export default function($form) {
  var $params=$form.getExtForm();
  if (!$form.isValid(true)) {
    return;
  }

  var activity = $params.activity;
  /*var agentRecordActs = {};
  var canAgentRecordActivityIds = activity.canAgentRecordActivityIds;
  var canAgentRecordActivityNames = activity.canAgentRecordActivityNames;
  if(canAgentRecordActivityIds && null != canAgentRecordActivityIds){
    var arActIds = canAgentRecordActivityIds.split(',');
    var arActNames = canAgentRecordActivityNames.split(',');
    if(arActIds.length> 0){
      for(var i=0; i< arActIds.length; i++){
        agentRecordActs[arActIds[i]] = {id:arActIds[i], name:arActNames[i]};
      }
    }
  }
  if(agentRecordActs.length<1){
    PF.message('info', '未设置代录节点，请与管理员联系!');
    return;
  }*/

  var agentRecordFlowIds = [];
  var canAgentRecordFlowIds = activity.canAgentRecordFlowIds;
  if(canAgentRecordFlowIds && null != canAgentRecordFlowIds){
    var arFlowIds = canAgentRecordFlowIds.split(',');
    if(arFlowIds.length> 0){
      for(var i=0; i< arFlowIds.length; i++){
        agentRecordFlowIds[i] = arFlowIds[i];
      }
    }
  }
  if(agentRecordFlowIds.length<1){
    PF.message('info', '未设置代录节点流向，请与管理员联系!');
    return;
  }
  var p ={
    taskId:$params.taskId,
    appId:$params.appId,
    formId:$params.formId,
    activity:$params.activity,
    //agentRecordActs:agentRecordActs,
    agentRecordFlowIds:agentRecordFlowIds
  }
  PF.show('flowVirtualog',p, function(res){
    $params.refreshComment(res);
  });
}



// WEBPACK FOOTER //
// ./src/common/components/extend/form/src/config/flow-virtuallog.js